import Vue from 'vue'
import Router from 'vue-router'
import routes from '@/config/routes.js'

Vue.use(Router)

const router = new Router(routes);

// router.beforeEach((to, from, next) => {
//     if (to.meta.title) {
//         document.title = to.meta.title;
//     }
//     next();
// });

export default router;